import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { blue500, grey300 } from 'material-ui/styles/colors';
import { List } from 'material-ui/List';
import IconButton from 'material-ui/IconButton';
import { MessageDialog } from './MessageDialog';
import { Subheader, FontIcon } from 'material-ui';
import MessageItem from './MessageItem';
import MessageGroup from './MessageGroup';
import Main from 'src/layout/Main';
var styles = {
    container: {
        display: 'flex',
        alignItems: 'stretch',
        height: '95vh',
        maxHeight: '95vh',
        backgroundColor: grey300
    },
    groups: {
        flex: .2,
        alignSelf: 'stretch',
        borderRight: "1px solid " + grey300,
        backgroundColor: 'white',
    },
    messages: {
        flex: 1,
        alignSelf: 'stretch',
        padding: '1rem',
        overflowY: 'auto'
    }
};
var Messages = /** @class */ (function (_super) {
    tslib_1.__extends(Messages, _super);
    function Messages(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isMessageDialogOpen: false
        };
        _this.handleGroupSelect = function (userId) {
            _this.messages.selectedMessageUserId = userId;
        };
        _this.handleNewMessage = function (e) {
            e.preventDefault();
            _this.setState({ isMessageDialogOpen: true });
        };
        _this.handleMessageSend = function (user, message) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ isMessageDialogOpen: false });
                        return [4 /*yield*/, this.messages.send(user.id, message)];
                    case 1:
                        _a.sent();
                        this.scrollToBottom();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleMessageSendCancel = function () {
            _this.setState({ isMessageDialogOpen: false });
        };
        _this.containerRef = React.createRef();
        return _this;
    }
    Messages.prototype.componentDidUpdate = function (_) {
        this.scrollToBottom();
    };
    Messages.prototype.scrollToBottom = function () {
        var target = this.containerRef.current;
        var maxScrollTop = target.scrollHeight - target.clientHeight;
        target.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
    };
    Object.defineProperty(Messages.prototype, "messages", {
        get: function () {
            return this.props.userStore.messages;
        },
        enumerable: true,
        configurable: true
    });
    Messages.prototype.render = function () {
        var _this = this;
        var store = this.props.userStore;
        if (!store.messages) {
            return null;
        }
        var groups = this.messages.userIdsFromMessages.map(function (i) { return store.getUserById(i); })
            .filter(function (user) { return !!user; })
            .map(function (user) { return React.createElement(MessageGroup, { key: user.id, user: user, store: store, onSelect: _this.handleGroupSelect }); });
        var messages = this.messages.selectedMessageGroup
            .map(function (message) { return React.createElement(MessageItem, { key: message.id, message: message, store: store }); });
        return (React.createElement(Main, null,
            React.createElement(MessageDialog, { isOpen: this.state.isMessageDialogOpen, onSendMessage: this.handleMessageSend, onCancel: this.handleMessageSendCancel }),
            React.createElement("div", { style: styles.container },
                React.createElement("div", { style: styles.groups },
                    React.createElement(List, null,
                        React.createElement(Subheader, null, "\u00DCzenet lista"),
                        groups),
                    React.createElement(IconButton, { tooltip: "\u00DAj \u00FCzenet", onClick: this.handleNewMessage },
                        React.createElement(FontIcon, { className: "material-icons", color: blue500 }, "add"))),
                React.createElement("div", { style: styles.messages, ref: this.containerRef }, messages))));
    };
    Messages = tslib_1.__decorate([
        inject('userStore'),
        observer
    ], Messages);
    return Messages;
}(React.Component));
export { Messages };



//////////////////
// WEBPACK FOOTER
// ./src/pages/messages/Messages.tsx
// module id = 798
// module chunks = 0